import Head from 'next/head';
import { IHomePageSchemaProps } from './types/IHomePageSchemaProps';

const HomePageSchema = ({ seoData }: IHomePageSchemaProps) => {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: seoData.name,
    alternateName: seoData.alternateName,
    url: seoData.url,
    logo: seoData.logo,
    sameAs: seoData.sameAs,
  };

  return (
    <Head>
      <script
        id="home-page-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(data),
        }}
      />
    </Head>
  );
};

export default HomePageSchema;
